import { render, staticRenderFns } from "./Decorator.vue?vue&type=template&id=0bd80498&scoped=true&"
import script from "./Decorator.vue?vue&type=script&lang=js&"
export * from "./Decorator.vue?vue&type=script&lang=js&"
import style0 from "./Decorator.vue?vue&type=style&index=0&id=0bd80498&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd80498",
  null
  
)

export default component.exports